import { FC } from "react";
import { useTranslation } from "react-i18next";
import { BotsGroupIcon } from "~@/icons";
import { sanitize } from "~@/utils";

const Maintenance: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="error error--is-fullheight error--is-flex-grow-1">
      <div className="error__code" style={{ marginBottom: 19 }}>
        <div className="icon icon--has-default-size">
          <BotsGroupIcon />
        </div>
      </div>
      <p className="error__title">
        {sanitize({ html: t("error.maintenance") })}
      </p>
    </div>
  );
};

export default Maintenance;
